import { en } from "./en";

export const fr: typeof en = {
  languages: {
    de: "De",
    en: "En",
    zh: "中文",
    pt: "Pt",
    fr: "Fr",
  },
  seoDefaults: {
    albis: {
      title: "ALBIS - Easy, Smart, passionate.",
      brandPrefix: "ALBIS - ",
      description:
        "Distribution de polymères. Experts techniques et conseillers pour toutes les questions relatives aux plastiques. L'un des portefeuilles les plus larges au monde.",
    },
    mocom: {
      title: "MOCOM - L'excellence du compoundage.",
      brandPrefix: "MOCOM - ",
      description: "Compoundage de polymères.",
    },
    krahnCeramics: {
      title:
        "KRAHN Ceramics - Partenaire de projet innovant pour le traitement des poudres céramiques et métalliques",
      brandPrefix: "KRAHN CERAMICS - ",
      description:
        "En tant que partenaire technologique expérimenté dans le domaine de la céramique et du métal, nous accompagnons les développeurs de produits dans la réalisation des idées de demain tout au long de la chaîne de valeur : des poudres céramiques ou métalliques jusqu'à la production de pièces finies.",
    },
    ottoKrahnGroup: {
      title: "Otto Krahn Group – Réinventé.",
      brandPrefix: "Otto Krahn Group - ",
      description:
        "Votre partenaire de confiance depuis 111 ans pour les plastiques et la chimie adopte une nouvelle structure : ALBIS, KRAHN, MOCOM, WIPAG réunis au sein de la nouvelle société holding.",
    },
    htf: {
      title: "KRAHN Heat Transfer Fluids - Partenaire officiel d'Eastman",
      brandPrefix: "KRAHN Heat Transfer Fluids - ",
      description:
        "Sélection du fluide caloporteur adapté dans le portefeuille Therminol®/Marlotherm™. Conseils complets sur les réchauffeurs, les pompes et les technologies de traitement de l'air extrait.",
    },
    wipag: {
      title: "WIPAG",

      brandPrefix: "WIPAG - ",
      description:
        "Spécialiste de la production de compounds par transformation des plastiques ainsi que de la mise en œuvre de concepts individuels d'économie circulaire.",
    },
    plgrd: {
      title: "Playground",
      brandPrefix: "Playground - ",
      description: "Pour jouer avec le sol",
    },
    krahnChemie: {
      title: "KRAHN Chemie",
      brandPrefix: "KRAHN Chemie - ",
      description: "KRAHN Chemie",
    },
    okNewBusiness: {
      title: "Otto Krahn New Business",
      brandPrefix: "Otto Krahn New Business",
      description: "Otto Krahn New Business",
    },
  },
  header: {
    contact: "Contact",
    outline: "Aperçu",
  },
  search: {
    search: "Rechercher",
    label: "Rechercher",
    lastSearches: "Vos dernières recherches",
    directEnter: "Accès direct",
    files: "Fichiers",
    stories: "Articles",
    pages: "Pages",
    products: "Produits",
    press: "Communiqué de presse",
    industries: "Secteurs",
    results: "résultats pour",
    more: "afficher plus",
    noResults: "Aucun résultat pour",
    adjustSearch: "Veuillez ajuster votre recherche et réessayer.",
    download: "Téléchargement",
    short: "Votre terme de recherche est trop court.",
    entrances: {
      albis: [
        {
          link: "/fr/products/product-search/",
          label: "Fiches techniques",
        },
        {
          link: "/fr/services/quality-management",
          label: "Certificats",
        },
        {
          link: "/fr/products/brochures",
          label: "Fiches de données de sécurité",
        },
      ],
      wipag: [
        {
          link: "/fr/downloads",
          label: "Téléchargements et certificats",
        },
      ],
      mocom: [
        {
          link: "/fr/products/product-search#/",
          label: "Fiches techniques",
        },
        {
          link: "/fr/downloads",
          label: "Fiches de données de sécurité et certificats",
        },
      ],
      ottoKrahnGroup: [{ link: "/fr/brands", label: "Marques" }],
      krahnChemie: [{ link: "/fr/markets", label: "Marchés" }],
    },
  },
  products: {
    viewProduct: "Voir le produit",
    back: "Retour à l'aperçu",
  },
  newsletter: {
    mandatory: "* champ obligatoire",
  },
  contact: {
    phone: "Téléphone :",
    fax: "Fax :",
    email: "E-mail :",
    writeEMail: "Écrire un e-mail",
    form: {
      button: "Envoyer",
      send: "Envoyer",
      placeholder: {
        email: "E-mail",
        name: "Nom",
        company: "Société (facultatif)",
        companyReq: "Société",
        subject: "Objet",
        street: "Rue",
        apartmentNumber: "Numéro de rue",
        plz: "Code postal",
        city: "Ville",
        message: "Décrivez votre défi :",
        country: "Pays",
        startup: "Société",
        comment: "Commentaire",
        phone: "Téléphone",
      },
      label: {
        message: "Votre message",
      },
      success: "Merci ! Votre message a été envoyé.",
      error:
        "Une erreur s'est produite. Veuillez réessayer plus tard ou nous contacter via info@albis.com.",
    },
  },
  contactFinder: {
    title: "Votre contact",
    description:
      "Pour mieux répondre à vos questions, veuillez saisir ici votre localité et votre code postal. L'interlocuteur approprié s'affichera alors.",
    findAction: "Rechercher",
    zipCodeLabel: "Code postal",
    countryLabel: "Choisir le pays",
    contactPersonTitle: "Interlocuteur",
    warningMessage:
      "Malheureusement, nous n'avons pas pu trouver d'interlocuteur. Veuillez vérifier les informations saisies pour le pays et le code postal.",
    contactButton: "Demander un contact",
  },
  contactFinderV2: {
    countryLabel: "Choisir le pays",
    loadingText: "Chargement...",
  },
  contactDialog: {
    title: "Demander un contact",
    contactByPhoneActionLabel:
      "Veuillez me rappeler au numéro de téléphone suivant :",
    dataProtectionConsentActionLabel:
      "J'accepte la <a href='https://www.albis.com/fr/privacy' target='_blank'>politique de protection des données</a>.",
    requestMsgLabel: "Indiquez-nous le motif de votre demande",
    submit: "Envoyer le message",
    requestMessage: "Saisissez ici",
    successTitle: " Nous reviendrons vers vous",
    successDescription:
      "Votre demande a bien été envoyée. Nous vous contacterons dans les meilleurs délais.",
    errorDescription: "Une erreur s'est produite.",
    successBtnLabel: "Retour à la page",
  },
  media: {
    press: {
      categories: {
        products: "Produits",
        company: "Entreprise",
        "shows-and-events": "Salons et événements",
        "healthcare-solutions": "Solutions de santé",
        extrusion: "Extrusion",
        "smart-plastics-at-home": "Smart plastics@home",
        sustainability: "Durabilité",
        "markets-industry": "Marchés / Industrie",
        "success-story": "Témoignage de réussite",
        "expert-article": "Article d'expert",
        events: "Événements",
      },
      loadMore: "Charger plus",
    },
    events: {
      addToCalendar: "Ajouter au calendrier",
    },
    filter: {
      year: "Année de publication",
      topic: "Sujet",
    },
    noResults: "Aucune entrée",
  },
  markets: {
    cases: "Études de cas",
    productInformation: "Informations sur le produit",
    categories: {
      interior: "Intérieur",
      exterior: "Extérieur",
      "under-the-hood": "Sous le capot",
      outdoor: "Outils de jardinage",
      hvac: "Chauffage, ventilation, climatisation",
      furniture: "Mobilier",
      kitchenware: "Petit électroménager et articles ménagers",
      sanitary: "Sanitaire",
      tools: "Outils électroportatifs",
      wintersports: "Sports de montagne et d'hiver",
      sportswear: "Vêtements de sport",
      marine: "Sports nautiques",
      materials: "Matériaux",
      vehicles: "Véhicules",
      trains: "Trains",
      digger: "Pelleteuse",
      solar: "Énergies renouvelables",
      radio: "Radio",
      video: "Systèmes de sûreté et de sécurité",
      computer: "Gros électroménager",
      lights: "Technologie d'éclairage",
      electricity: "Installation électrique",
      machine: "Machines",
      robots: "Robots",
      aircondition: "Climatisation",
      safety: "Sécurité",
      monitors: "Moniteurs",
      controlling: "Contrôle",
      tubes: "Tubes",
      bedside: "Matériel de chevet",
      packaging: "Emballage",
      bicycle: "Sports cyclistes",
      household: "Aides ménagères",
      "post-industrial": "Recyclage post-industriel",
      renewable: "Énergies renouvelables",
      mechanical: "Recyclage mécanique",
      energy: "Recyclage énergétique",
      biobased: "Ressources biosourcées",
      "post-consumer": "Recyclage post-consommation",
      diagnostic: "Diagnostic in vitro, matériel de laboratoire et biosciences ",
      infusion: "Dispositifs médicaux - Systèmes de perfusion",
      "drug-delivery": "Dispositifs médicaux - Systèmes d'administration de médicaments",
      monitoring: "Dispositifs médicaux - Soins intensifs et surveillance des patients",
      "medical-packaging":
        "Emballage de produits pharmaceutiques et de dispositifs médicaux",
      "medical-devices":
        "Autres dispositifs médicaux - domaine d'application chirurgie, rééducation, don du sang, vaccination (exemples)",
    },
  },
  okg: {
    jobTeaser: {
      student: "Étudiants",
      graduate: "Diplômés",
      youngprofessional: "Jeunes professionnels",
      professional: "Professionnels",
    },
    pressTeaser: {
      news: "Actualités",
      readMore: "Article complet",
    },
    privacy: "Politique de confidentialité",
  },
  htf: {
    tempRange: "Plage de température :",
    modeDetails: "plus de détails",
    close: "fermer",
    searchPlaceholder: "Rechercher un produit",
    typicalApplication: "Applications typiques",
    descriptionOfServices: "Description des services",
    productData: "Données produit",
    thermometerDescription:
      "Veuillez déplacer les curseurs pour filtrer les produits.",
    thermometerMinLabel: "Température min. (°C)",
    thermometerMaxLabel: "Température max. (°C)",
    resetFilter: "Réinitialiser le filtre",
    filter: "Filtrer",
    tempRangeFormat: "#t1#° à #t2#°C",
    productInformation: {
      tempRange: "Plage de température",
      optimalUsageTemp: "Température d'utilisation optimale",
      maxBulkTemp: "Température de masse recommandée °C",
      maxExtendedBulkTemp: "Température de masse prolongée max. °C",
      maxFilmTemp: "Température de film max. °C",
      boilingPoint: "Point d'ébullition °C @ 1013 mbar ",
      pumpability: "Pompabilité °C @ 300 mm²/s (cSt)",
      pourPoint: "Point d'écoulement °C",
      crystallizingPoint: "Point de cristallisation °C",
      slurryPoint: "Point de boue °C",
      flashPointD93: "Point d'éclair °C (ASTM D93)",
      flashPointD92: "Point d'éclair °C (ASTM D92)",
      autoignitionTempDIN51794: "Température d'auto-inflammation °C (DIN 51794)",
      autoignitionTempASTME659: "Température d'auto-inflammation °C (ASTM E-659)",
      density20: "Densité @ 20°C (kg/m³)",
      density25: "Densité @ 25°C (kg/m³)",
      density80: "Densité @ 80°C (kg/m³)",
      kinematicViscosity25: "Viscosité cinématique @ 25°C (mm²/s)",
      kinematicViscosity40: "Viscosité cinématique @ 40°C (mm²/s)",
      kinematicViscosity80: "Viscosité cinématique @ 80°C (mm²/s)",
      waterClass: "Classe de risque pour l'eau",
      approval: "Homologation",
    },
    pTypicalApplication: {
      "product-ta-oil": "Traitement du pétrole et du gaz",
      "product-ta-ng-purification": "Purification du gaz naturel",
      "product-ta-refining": "Raffinage",
      "product-ta-aps": "Traitement et stockage de l'asphalte",
      "product-ta-gtl": "Gas To Liquid (GTL)",
      "product-ta-pp-manufacturing": "Fabrication de plastiques et de polymères",
      "product-ta-shp-manufacturing":
        "Fabrication de polymères spéciaux thermosensibles",
      "product-ta-sfm": "Fabrication de fibres synthétiques",
      "product-ta-plastic-molding": "Moulage de plastique",
      "product-ta-pharmaceutical-manufacturing": "Fabrication pharmaceutique",
      "product-ta-chiral-chemical-processes": "Procédés chimiques chiraux",
      "product-ta-environmental-test-chambers": "Chambres d'essais climatiques",
      "product-ta-specialty-chemical-manufacturing":
        "Fabrication de produits chimiques spéciaux",
      "product-ta-chemical-manufacturing": "Fabrication de produits chimiques",
      "product-ta-concentrated-solar-power": "Énergie solaire concentrée",
      "product-ta-orc": "Cycle organique de Rankine (ORC)",
      "product-ta-biofuel": "Fabrication de biocarburants",
      "product-ta-foodbeverage-processing": "Transformation agroalimentaire et des boissons",
      "product-ta-mdf": "Panneau de fibres à densité moyenne (MDF)",
      "product-ta-desalination": "Dessalement",
      "product-ta-htsm": "Maintenance des systèmes de transfert de chaleur",
    },
    checkboxHeadline: "Choisir une application",
    tempRangeHeadline: "Plage de température °C",
    checkboxFilterLabels: {
      heatingAndRecovery: "Chauffage/récupération de chaleur",
      heatingAndCooling: "Chauffage/refroidissement",
      cooling: "Refroidissement",
      thermoRegulation: "Thermorégulation",
      foodgrade: "Qualité alimentaire",
    },
    noProductsFound: "Nous n'avons trouvé aucun produit correspondant à vos critères.",
    wrongProductId: {
      title: "Produit introuvable",
      text: "Nous n'avons trouvé aucun produit correspondant à vos critères.",
      cta: "Vers l'aperçu",
    },
    contactHeader: {
      slogan: "Des solutions d'huiles thermiques fiables.",
      contactUs: "Parlez à notre équipe",
      phone: "+31 75 70010 15",
      mail: "htf@krahn.eu",
    },
    globalContactForm: {
      headline: "Trouvez votre solution d'huile thermique dès aujourd'hui !",
      talkToUs: "Contactez-nous maintenant",
      mail: "E-mail",
      phone: "Téléphone",
      askForCallback: "Envoyer la demande",
      dropDownDefault: "Comment pouvons-nous vous aider ?",
      dropDown: {
        technicalConsultation: "Demande de conseil technique",
        requestSample: "Demande d'échantillon d'huile",
        requestOffer: "Demande d'offre",
        requestCallback: "Demande de rappel",
      },
      success: "Merci ! Votre message a été envoyé avec succès.",
      error: "Une erreur s'est produite. Veuillez réessayer plus tard.",
    },
    readMore: "En savoir plus",
  },
  krahnCeramics: {
    openImage: "Ouvrir l'image",
  },
  krahnChemie: {
    contact: {
      form: {
        placeholder: {
          message: "Saisissez votre message",
        },
      },
    },
  },
  scroll: "Faites défiler pour découvrir",
  brochure: "Brochures",
  productInformation: "Informations sur le produit",
  innovationChallenge: {
    jobs: {
      student: "Étudiant(e)",
      startUpStaff: "Employé(e) d'une start-up intéressé(e) à participer au challenge",
      universityStaff:
        "Chercheur/Personnel scientifique d'une université, d'une école supérieure, d'un institut ou d'un établissement comparable",
    },
  },
  redirect: {
    title: "Une erreur s'est produite.",
    text: "Vouliez-vous dire {{}} ?",
    buttonLabel: "Vers la page correcte",
  },
  pageNotFound: {
    title: "Cette page est introuvable (404)",
    text: "Cette page est introuvable, veuillez revenir en arrière.",
    buttonLabel: "Retour",
  },
  clientArea: {
    successMessage: "Votre demande a été envoyée avec succès.",
    errorMessage:
      "Une erreur est survenue. Veuillez réessayer et vérifier les données saisies.",
    titleOrder: "Votre n° de commande : ",
    titleAlbisNr: "Votre n° de commande Albis : ",
    materialName: "Nom du matériau",
    materialNumber: "N° de matériau",
    dataSource: "Fiche technique",
    sdb: "FDS",
    apz: "COA",
    orderNr: "N° de commande",
    orderNrLong: "Numéro de commande",
    albisNr: "N° de commande",
    date: "Date",
    name: "Nom",
    documentLabel: "Document",
    backToOverview: "Retour à l'historique des commandes",
    contactBoxTitle: "Votre contact",
    contactBoxAction: "Demander un rappel",
    orderInsight: {
      orderConfirmation: "Confirmation de commande",
      orderNumberLabel: "Votre n° de commande : ",
      safetySheetLabel: "Fiche de données de sécurité",
      status: "Statut : ",
      estDeliveryDate: "Date de livraison estimée",
      materialQuantity: "Quantité de matériau ",
      deliveryDocs: "Documents de commande",
      albisDeliveries: "Livraisons Albis",
    },
    albisOrderInsight: {
      partOfOrder: "Votre n° de commande :",
      showOrder: "Afficher la commande",
      materialName: "Nom du matériau",
      materialNumber: "N° de matériau",
      amount: "Quantité",
      chargeId: "N° de lot",
      materials: "Matériaux",
    },
    productOrderDialog: {
      title: "Commander à nouveau le produit",
      description:
        "Si vous souhaitez commander à nouveau ce produit, veuillez remplir le formulaire ci-dessous et le collaborateur Albis concerné vous contactera.",
      placeholder: {
        company: "Entreprise",
        useCase: "Application (facultatif)",
        useCase2: "Application",
        technicalRequirements: "Exigences techniques (facultatif)",
        technicalRequirements2: "Exigences techniques",
        volume: "Volume",
        enterHere: "Veuillez saisir",
        color: "Couleur",
        product: "Produit",
      },
      phoneRecallLabel: "Veuillez me rappeler au numéro indiqué.",
      moreProductsLabel: "Je suis intéressé par d'autres produits.",
      productNameLabel: "Produit sélectionné : ",
      notesLabel: "Commentaires supplémentaires",
      fileUploadLabel: "Téléverser un document",
      submitBtnLabel: "Envoyer la demande",
    },
    productRequestDialog: {
      title: "Quel type de produit recherchez-vous ?",
      description:
        "Vous ne savez pas quel est le bon matériau pour votre application. Remplissez le formulaire ci-dessous et laissez nos experts vous aider dans votre décision.",
    },
    filter: {
      timeRange: "Sélectionner la période de livraison",
      refresh: "Actualiser",
    },
    sdbHint: "FDS signifie Fiches de données de sécurité ",
    apzHint: "COA signifie",
    login: {
      title: "Connexion",
      form: {
        mail: "E-mail*",
        customerNr: "N° de client*",
        orderNr: "N° de commande (facultatif)",
        hint:
          "En saisissant votre numéro de commande, vous pouvez accéder directement à la commande.",
      },
      stayLoggedIn: "Rester connecté",
      modal: {
        headline: "Vous avez reçu un e-mail",
        text:
          "Nous vous avons envoyé un lien magique à votre adresse e-mail. Si vous ouvrez le lien, vous serez redirigé vers la page de récapitulatif des commandes. ",
      },
    },
    downloadsHint: "Le téléchargement des documents sera bientôt disponible",
    orderDownloadsHint: {
      label: "Le téléchargement du document n'est actuellement pas disponible. ",
      link: "Vous pouvez également nous contacter.",
    },
    moreOrders: "Autres commandes en cours",
    openOrder: "Ouvrir la commande",
    error: {
      title: "Une erreur est survenue.",
      albisIdText:
        "Nous n'avons rien trouvé sous ce numéro de commande Albis. Veuillez vérifier votre saisie.",
      orderIdText:
        "Nous n'avons rien trouvé sous ce numéro de commande Albis. Veuillez vérifier votre saisie.",
    },
    upload: {
      title: "Téléverser un document",
      success: "a été téléversé avec succès.",
      hint: "Supprimer le fichier",
      error: "Le téléversement du fichier a échoué. Veuillez réessayer.",
    },
    startCall: {
      title: "Prenez contact...",
      text:
        "Si vous souhaitez obtenir plus d'informations sur le produit que vous avez choisi, remplissez le formulaire ci-dessous et nos experts vous contacteront pour en discuter.",
      productAdornment: "Produit : ",
    },
    states: {
      ordered: "Commandé",
      confirmed: "Confirmé",
      scheduled: "Planifié",
      shipped: "Expédié",
      delivered: "Livré",
      unknown: "Inconnu",
      inProgress: "En cours",
    },
  },
  recyclingForm: {
    polymer: "Polymère",
    mold: "Moule",
    filler: "Charge",
    color: "Couleur",
    amount: "Quantité en kg",
    description: "Description",
    adhesion: "Autre adhérence",
    moreInfo: "Informations complémentaires",
    wasteDescription: "Description du déchet",
    quantityPerYear: "Quantité générée par an (t/a)",
    currentUse: "Utilisation actuelle (vente/élimination)",
    targetCustomer: "Cible",
    closedLoop: "Boucle fermée",
    openLoop: "Boucle ouverte",
    requirementsForFinishedProduct: "Exigences pour le produit fini",
    additionalInfo: "Informations complémentaires, par ex. durée de fonctionnement",
    personalInfo: "Vos informations",
    name: "Nom, Prénom",
    address: "Adresse",
    email: "E-mail",
    phone: "Téléphone",
    message: "Saisissez un message ici",
    submit: "Envoyer le formulaire",
    save: "Enregistrer",
    delete: "Supprimer",
    add: "Ajouter d'autres déchets",
    success: "Merci ! Votre message a été envoyé.",
    errorMocom: "Une erreur s'est produite. Veuillez réessayer plus tard ou nous contacter via info@mocom.eu.",
    error:
      "Une erreur s'est produite. Veuillez réessayer plus tard ou nous contacter via info@wipag.com.",
    notSaved: "Pas encore enregistré",
    tooltips: {
      wasteDescription: {
        heading: "Informations nécessaires :",
        text: "Application (génération du déchet)\nMatières plastiques contenues et impuretés/adhérences, revêtement existant (par ex. peinture)\nType et teneur en charge : par ex. fibre de verre, talc, carbone en %\nÉtat : Composants, chutes, déchets de poinçonnage, carottes, matière broyée, matière régénérée, etc."
      },
      targetCustomer: "Boucle fermée = la matière est restituée aux clients (fraction cible)\nBoucle ouverte = reprise des déchets pour recyclage et vente",
      requirementsForFinishedProduct: {
        heading: "Questions :",
        text: "Exigences réglementaires (par ex. : FDA/UL/NSF/GMP/Médical), homologations\nSpécification (par ex. : propriétés mécaniques ou rhéologiques, couleur)"
      },
    },
  },
  floatingButtonWipag: "Achat de plastique",
  regions: {
    de: "Allemagne",
    at: "Autriche",
    ch: "Suisse",
    uk: "Royaume-Uni",
    ie: "Irlande",
    pl: "Pologne",
    ro: "Roumanie",
    cz: "République tchèque",
    hu: "Hongrie",
    sk: "Slovaquie",
    be: "Belgique",
    nl: "Pays-Bas",
    lu: "Luxembourg",
    it: "Italie",
    fr: "France",
    es: "Espagne",
    cn: "Chine",
    gr: "Grèce",
    il: "Israël",
    ru: "Russie",
    se: "Suède",
    no: "Norvège",
    fi: "Finlande",
    dk: "Danemark",
    is: "Islande",
    bg: "Bulgarie",
    lv: "Lettonie",
    ee: "Estonie",
    lt: "Lituanie",
    ba: "Bosnie-Herzégovine",
    hr: "Croatie",
    me: "Monténégro",
    mk: "Macédoine",
    si: "Slovénie",
    rs: "Serbie",
    cy: "Chypre",
    li: "Liechtenstein",
    pt: "Portugal",
    xk: "Kosovo",
    ua: "Ukraine",
  },
  productArea: {
    selectRegion: "Découvrez ce qui est disponible dans votre région",
    filterApplication: "Filtrer par applications",
    filterSolution: "Filtrer par solutions",
    filterIdea: "Filtrer par idées",
    filterManufacturer: "Filtrer par fabricant",
    filterLubricants: "Filtrer par lubrifiants",
    filterFuels: "Filtrer par carburants",
    industry: "Sélectionner un secteur",
    contact: "Contact",
    contactButton: "Coordonnées",
    back: "Retour à l'aperçu",
    characteristics: "Caractéristiques du produit",
    brands: "Marques",
    producer: "Producteur",
    application: "Application",
    ideas: "Idées",
    lubricants: "Lubrifiants",
    fuels: "Carburants",
    manufacturer: "Fabricant",
    availability: "Disponible dans",
    search: "Rechercher par nom de produit",
    searchResults: "Résultats pour :",
    showAllProducts: "Afficher tous les groupes de produits de {{}}",
    noResults: "Aucun résultat trouvé",
    noContentMaintained:
      "Il semble qu'il n'y ait aucun contenu dans ce secteur. Veuillez revenir plus tard !",
    resetFilter: "Réinitialiser le filtre",
    allCountries: "Choisissez votre pays",
  },
  jobpages: {
    applyNow: "Postuler maintenant !",
    bePartOfTeam: "Rejoignez notre équipe en tant que :",
    tasks: {
      title: "Vos missions",
      main: "Missions principales",
      additional: "Autres missions",
    },
    profile: {
      title: "Votre profil",
      skills: "Expérience et savoir-faire",
      personality: "Personnalité",
    },
    offers: "Offres sur le marché de l'emploi",
    showOffers: "Afficher {{}} offres",
    selection: "Votre sélection",

    filterArea: {
      freeText: "Mots-clés",
      freeTextPlaceholder: "Mot-clé, ID de l'offre",
      department: "Fonction",
      fallbackDepartment: "Toutes les fonctions",
      location: "Lieu",
      fallbackLocation: "Tous les lieux",
      level: "Niveau d'entrée",
      fallbackLevel: "Tous les niveaux d'entrée",
      company: "Division",
      fallbackCompany: "Toutes les divisions",
    },
    contract: {
      limited: "à durée déterminée",
      unlimited: "à durée indéterminée",
    },
    level: {
      starter: "Débutants",
      professional: "Professionnels",
      students: "Étudiants",
      graduate: "Jeunes diplômés",
    },
    pagesPerPage: "Offres par page",
    error: {
      jobDetail:
        "Une erreur s'est produite lors du chargement des détails de l'offre. Veuillez réessayer ultérieurement.",
      jobboard:
        "Une erreur s'est produite lors du chargement des offres d'emploi. Veuillez réessayer ultérieurement.",
    },
    sortingLabel: "Trier par",
    sortingOptions: {
      companyAsc: "Entreprises croissant",
      companyDesc: "Entreprises décroissant",
      titleAsc: "Intitulé du poste croissant",
      titleDesc: "Intitulé du poste décroissant",
      startOfWorkAsc: "Date de prise de poste croissant",
      startOfWorkDesc: "Date de prise de poste décroissant",
      locationAsc: "Lieu croissant",
      locationDesc: "Lieu décroissant",
    },
    departments: {
      finance: "Finance, comptabilité et contrôle de gestion",
      customerService: "Service client",
      graphics: "Design graphique et architecture",
      distribution: "Vente et commerce",
      management: "Direction et développement de l'entreprise",
      it: "Informatique et développement logiciel",
      law: "Droit",
      purchase: "Achats, gestion des matières et logistique",
      marketing: "Marketing et publicité",
      others: "Autres disciplines",
      projectManagement: "Gestion de projet",
      production: "Production et fabrication",
      pr: "Relations publiques et journalisme",
      processPlanning: "Planification des processus et assurance qualité",
      teaching: "Enseignement, R&D",
      health: "Santé, médical et social",
      consulting: "Conseil",
      administration: "Administration",
      engineering: "Ingénierie et technique",
      hr: "Ressources humaines",
      productManagement: "Gestion de produits",
      analysis: "Analyse et statistiques",
    },
    errorDetails: {
      title: "Offre introuvable",
      text:
        "Malheureusement, l'annonce demandée n'existe plus. Veuillez lancer une nouvelle recherche.",
      buttonLabel: "Retour",
    },
    errorJobboard: {
      title: "Une erreur s'est produite",
      text: "Le chargement des offres d'emploi a échoué. Veuillez réessayer ultérieurement.",
      buttonLabel: "Réessayer",
    },
    noJobsFound: {
      title: "Désolé, votre recherche n'a donné aucun résultat.",
      text: "Modifiez vos critères et n'hésitez pas à réessayer.",
    },
    position: {
      fulltime: "Temps plein",
      parttime: "Temps partiel",
      intern: "Stage",
      freelance: "Indépendant",
      owner: "Propriétaire",
      partner: "Associé",
      board: "Membre du conseil de surveillance",
      honorary: "Poste honorifique",
      partFull: "Temps partiel / Temps plein",
      trainee: "Programme de formation",
      help: "Aide temporaire",
      social: "Engagement social",
      apprentice: "Apprentissage",
      training: "Apprentissage",
      marginal: "Emploi marginal",
      student: "Étudiant en alternance",
      temp: "Temporaire / Saisonnier",
      dual: "Études en alternance",
    },
  },
  a11y: {
    showContent: "Activer pour afficher le contenu de {{}}",
  },
  altcha: {
    bot: "Je ne suis pas un robot.",
    error: "Une erreur s'est produite. Veuillez confirmer que vous n'êtes pas un robot.",
    verified: "Vous êtes vérifié.",
    waitAlert: "Veuillez patienter un instant.",
    verifying: "Vérification en cours...",
    expired: "Votre vérification a expiré. Veuillez réessayer.",
  },
};
